import template from './report_leave.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportLeaveViewModel
{
	constructor (page)
	{
		this.page = page;

		let today = new Date();
		let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);

		this.date_start = ko.observable(new Date('1990-01-01').toJSON().slice(0, 10));
		this.date_end = ko.observable(new Date(lastDay).toJSON().slice(0, 10));
		this.include_resigned = ko.observable(false);

		this.current_department_id = ko.observable(null);
		this.current_company_id = ko.observable(null);

		this.selected_company = ko.observable();
		this.selected_department = ko.observable();
		this.employees = ko.observableArray([]);
		this.leave_types = ko.observableArray([]);


		this.table_report = ko.observableArray([]);
		this.download_data = ko.observableArray([]);
		this.leave_types = ko.observableArray([]);
		
		this.sort_field = ko.observable('fullnames');
		this.sort_order = ko.observable('ASC');
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(10);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records = ko.observable(10);

		this.default_leave_types = ['Annual Leave', 'Sick Leave'];
		this.columns = ko.observableArray(['Employee']);
		this.visible_columns = ko.observableArray(['Employee']);
		
		this.load_saved_settings();
		this.visible_columns.subscribe((newColumns) => {
			this.save_settings();
		});

		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.page.updateData();
		});
		this.leave_types.subscribe((new_leave_types) => {
			let leave_type_columns = new_leave_types.map(lt => lt.description);
			this.columns(['Employee', ...leave_type_columns]);
			if (this.visible_columns().length === 1)
			{
				let default_columns = ['Employee', ...this.default_leave_types.filter(
					type => leave_type_columns.includes(type)
				)];
				this.visible_columns(default_columns);
			}
			let valid_columns = this.visible_columns().filter(col =>
				col === 'Employee' || leave_type_columns.includes(col)
			);

			if (valid_columns.length === 0)
				valid_columns = ['Employee'];
			this.visible_columns(valid_columns);
			this.save_settings();
		});
		
		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.page.loadTable();
		});


		this.include_resigned.subscribe((newText) => {
			this.page.updateData();
		});

		this.date_end.subscribe((newValue) => {
			if (this.date_end())
				this.page.updateData();
		});

		this.selected_company.subscribe((newValue) => {
            if (newValue != null) {
                this.current_company_id(newValue.company_id);
                this.page.loadLeaveTypes(); 
                this.page.updateData();
            } else {
                this.current_company_id(null);
                this.leave_types([]); 
                this.page.updateData();
            }
        });

        this.selected_department.subscribe((newValue) => {
            if (newValue != null) {
                this.current_department_id(newValue.department_id);
                this.page.loadLeaveTypes(); 
                this.page.updateData();
            } else {
                this.current_department_id(null);
                this.page.updateData();
            }
        });
	}

	sort_column(column) {
		if (column && column.trim() !== '') {
			if (this.sort_field() === column) {
				this.sort_order(this.sort_order() === 'ASC' ? 'DESC' : 'ASC');
			} else {
				this.sort_field(column);
				this.sort_order('ASC');
			}
			this.page.loadTable();
		}
	}

	page_click(page_number) {
		this.current_page_number(page_number);
		this.page.loadTable();
	}

	page_click (page_number)
	{
		this.current_page_number(page_number);
		this.page.updateData();
	};

	load_saved_settings()
	{
		try
		{
			let saved_settings = JSON.parse(localStorage.getItem('report_leave_settings')) || {};
			if (saved_settings.visible_columns)
				this.visible_columns(saved_settings.visible_columns);
		}
		catch (e)
		{
			console.warn('Failed to load saved settings:', e);
		}
	}
	save_settings()
	{
		try
		{
			let settings = {
				visible_columns: this.visible_columns(),
			};
			localStorage.setItem('report_leave_settings', JSON.stringify(settings));
		}
		catch (e)
		{
			console.warn('Failed to save settings:', e);
		}
	}

	async download_clicked(v, e) {
		if (this.current_company_id() == '' || this.current_company_id() == null || this.current_company_id() == undefined) {
			Grape.alerts.alert({
				type: 'error',
				message: tr('Please select a company and load the report before downloading the report.'),
				title: tr('Error')
			});
			return;
		}

	
		try {
			let data = {
				department_id: this.current_department_id(),
				company_id: this.current_company_id(),
				date_start: this.date_start(),
				date_end: this.date_end(),
				include_resigned: this.include_resigned(),
				offset: 0,
				limit: 999999
			};
	
			let res = await Grape.fetches.postJSON('/reports/leave_available_report', data);
			
			if (!res || !res.report || !res.report.employee_summary) {
				Grape.alerts.alert({
					type: 'error',
					message: tr('No data available for download.'),
					title: tr('Error')
				});
				Grape.loading.hide();
				return;
			}
			
			let current_visible_columns = this.visible_columns();
			let csv_content = [];
	
			let header_row = current_visible_columns.map(column => `"${column}"`);
			csv_content.push(header_row.join(','));
	
			const allRecords = res.report.employee_summary.map(record => {
				let processedRecord = {
					...record,
					fullnames: `${record.firstname} ${record.surname}`,
					leave_balances: {}
				};
	
				record.leave.forEach(leave => {
					processedRecord.leave_balances[leave.css_class_name] = 
						parseFloat(leave.closing_balance.toFixed(3));
				});
				return processedRecord;
			});
	
			if (allRecords.length > 0) {
				allRecords.forEach(employee => {
					let row = [];
	
					if (current_visible_columns.includes('Employee')) {
						let employeeName = employee.is_active_employee ?
							employee.fullnames :
							`${employee.fullnames} (Resigned)`;
						row.push(`"${employeeName}"`);
					}
	
					current_visible_columns.forEach(column_name => {
						if (column_name !== 'Employee') {
							let leave_type = this.leave_types().find(lt => lt.description === column_name);
							if (leave_type) {
								let balance = employee.leave_balances[leave_type.css_class_name] || 'N/A';
								row.push(`"${balance}"`);
							}
						}
					});
	
					csv_content.push(row.join(','));
				});
			} else {
				csv_content.push('"No matching records found."');
			}
	
			let csvString = csv_content.join('\n');
			let blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
			let link = document.createElement('a');
	
			link.href = URL.createObjectURL(blob);
			link.setAttribute('download', 'leave_available_report.csv');
	
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error('Error downloading report:', error);
			Grape.alerts.alert({
				type: 'error',
				message: tr('Failed to download report data'),
				title: tr('Error')
			});
		}
	}

	processEmployeeData(employeeData) {
	    return employeeData.map(employee => {
	        let processedEmployee = {
	            fullnames: `${employee.firstname} ${employee.surname}`,
	            is_active_employee: employee.is_active_employee,
	            leave_balances: {}
	        };
		
	        if (employee.leave) {
	            employee.leave.forEach(leave => {
	                processedEmployee.leave_balances[leave.css_class_name] = 
	                    parseFloat(leave.closing_balance.toFixed(3));
	            });
	        }
		
	        return processedEmployee;
	    });
	}

	show_report_help()
	{
		Grape.dialog.open('LeaveAvailableHelp', { 'employee_id': this.page.bindings.id }, {});
	}
}

class ReportLeavePage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportLeaveViewModel(this);
	}

	async init()
	{
		if (await Utils.redirectOnAccessDenied('AvailableLeaveReport'))
			return;

		document.title = tr('Leave Available (Real-Time)');
		window.current_page_title(tr('Leave Available (Real-Time)'));
	}
	
    async loadLeaveTypes() {
        if (!this.viewModel.current_company_id()) return;

        let res = await Grape.fetches.postJSON('/leave/get_department_leave_types', {
            company_id: this.viewModel.current_company_id(),
            department_id: this.viewModel.current_department_id(),
            include_resigned: this.viewModel.include_resigned()
        });

        if (res && res.department_leave_types) {
            this.viewModel.leave_types(res.department_leave_types);
        }
    }

    updateData() {
        if (this.viewModel.current_company_id() && 
            this.viewModel.date_end() && 
            this.viewModel.date_end() !== '') {
            this.loadTable();
        }
    }

    async getReportData(isDownload = false) {
        let data = {
            department_id: this.viewModel.current_department_id(),
            company_id: this.viewModel.current_company_id(),
            date_start: this.viewModel.date_start(),
            date_end: this.viewModel.date_end(),
            include_resigned: this.viewModel.include_resigned(),
            sort_field: this.viewModel.sort_field(),
            sort_order: this.viewModel.sort_order()
        };

        if (!isDownload) {
            data.limit = this.viewModel.current_page_size();
            data.offset = (this.viewModel.current_page_number() - 1) * data.limit;
        }

        return await Grape.fetches.postJSON('/reports/leave_available_report', data);
    }

    async loadTable() {
        let res = await this.getReportData();
        
        if (res && res.report && res.report.employee_summary) {
           this.viewModel.employees(this.viewModel.processEmployeeData(res.report.employee_summary));
            this.viewModel.page_count(Math.ceil(res.report.result_count / this.viewModel.current_page_size()));
            this.viewModel.pagination_summary(
                `Showing ${(this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size() + 1} to ${Math.min(this.viewModel.current_page_number() * this.viewModel.current_page_size(), res.report.result_count)} of ${res.report.result_count} entries`
            );
        } else {
            this.viewModel.table_report([]);
            this.viewModel.page_count(1);
            this.viewModel.pagination_summary('');
        }
    }
}

export default {
	route: '[/]report/report_leave',
	page_class: ReportLeavePage,
	template: template,
	template_filename: 'translation/report_leave'
};

